export default __webpack_public_path__ + "static/char-s-sp01-en-69c48c93726b0a882ec5882ebed2d9f1.png";